import { render, staticRenderFns } from "./HistoricalPosition.vue?vue&type=template&id=3cf7d598&scoped=true"
import script from "./HistoricalPosition.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoricalPosition.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoricalPosition.vue?vue&type=style&index=0&id=3cf7d598&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7d598",
  null
  
)

export default component.exports